// extracted by mini-css-extract-plugin
export var highlightFade = "_3p-4";
export var highlighted = "_3p-3";
export var table = "_3p-1";
export var tableContainer = "_3p-0";
export var totalsRow = "_3p-2";